import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import { combineReducers } from 'redux';
import config from '../../../../../config';
import * as utils from '../../shared/utils';
import localization from '../../shared/strings';
import UiBlocker from '../../services/UiBlocker';
import Logger from '../../services/Logger';

import { showErrorDialog, showDialog } from '../../components/dialog';
import middlewares from '../middlewares';
import Toast from '../../components/Toast';

import user from './user';
import customFields from './customFields';
import importReducer from './import';

const thunkExtra = {
  utils,
  localization,
  UiBlocker,
  Toast,
  Logger,
  showDialog,
  showErrorDialog,
};

const store = configureStore({
  reducer: combineReducers({
    user,
    customFields,
    import: importReducer,
  }),
  middleware: [thunk.withExtraArgument(thunkExtra), ...middlewares],
  devTools: config.env === 'development',
});

export default store;
